import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Ticket } from 'src/app/Models/ticket';
import { Ticketdetails } from 'src/app/Models/ticketdetails';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { NzNotificationService } from 'ng-zorro-antd';
import { DatePipe } from '@angular/common';
import { TransferTicketDrawerComponent } from '../transfer-ticket-drawer/transfer-ticket-drawer.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-ticketdetails',
  templateUrl: './ticketdetails.component.html',
  styleUrls: ['./ticketdetails.component.css'],
  providers: [DatePipe]
})

export class TicketdetailsComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: Ticket;
  @Input() data2 = [];
  @Input() newstr = ''
  @Input()QUESTION1
  @Input()dataList6
  folderName = "ticket"
  userId = Number(this.cookie.get('userId'))
  ticketDetailsData: Ticketdetails
  DESCRIPTION
  DESCRIPTIONS
  PRIORITY
  fileDataLOGO_URL: File = null
  ID
  date1: string;
  isSpinning = false;
  imageSrc = '';
  todayDate = new Date();

    uploadPercent: number = 0;
  constructor(private cookie: CookieService, private datePipe: DatePipe, private api: ApiService, private message: NzNotificationService,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getAllEmployee();
  }


downloadFile(url: any) {
  console.log("2345",url)
  const link = document.createElement('a');
  link.href = url; // Use your API URL builder
  // link.download = url;
    link.download = this.getFileName(url); 
  link.click();
}
fileType: string = '';
getFileType(url: string): string {
  if (!url) return 'unknown';

  const parts = url.split('.');
  const ext = parts.length > 0 ? parts[parts.length - 1].toLowerCase() : '';

  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
  if (['pdf'].includes(ext)) return 'pdf';
  if (['doc', 'docx'].includes(ext)) return 'doc';
  if (['xls', 'xlsx'].includes(ext)) return 'excel';

  return 'other';
}
  empList = [];

  getAllEmployee() {
    this.empList = [];

    this.api.getAllemployeeMaster(0, 0, 'ID', 'desc', ' AND  ORG_ID =' + this.cookie.get('orgId')).subscribe(data => {
      if (data['code'] == 200) {
        this.empList = data['data'];
      }

    }, err => {
      console.log(err);
    });
  }

  getSenderEmpName(senderEmpID): any {
    let empName = '';
    this.empList.filter(obj => {
      if (obj.ID == senderEmpID) {
        empName = obj['NAME'];
      }
    });

    return empName;
  }

  send(data1: Ticket) {
    this.date1 = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');
    var LOGO_URL = '';

    if (this.DESCRIPTION != undefined && this.DESCRIPTION.trim() != '') {
      this.isSpinning = true;

      if (this.fileDataLOGO_URL) {
        var number = Math.floor(100000 + Math.random() * 900000)
        var fileExt = this.fileDataLOGO_URL.name.split('.').pop();
        var Dates = new Date();
        var formatedDate = this.datePipe.transform(Dates, 'yyyyMMddHHmmss');
        var url = formatedDate + number + "." + fileExt;

        this.api.onUpload2(this.folderName, this.fileDataLOGO_URL, url).subscribe(successCode => {
          if (successCode['code'] == "200") {
  var LOGO_URL = url;
    this.imageSrc = this.api.baseUrl + "static/ticket/" + LOGO_URL;

            var ticketDetailsData1 = {
              ID: 0,
              SENDER: "S",
              CLIENT_ID: this.api.clientId,
              SENDER_ID: this.userId,
              TICKET_MASTER_ID: data1.ID,
              DESCRIPTION: this.DESCRIPTION,
              URL: LOGO_URL,
              PRIORITY:this.PRIORITY
            }

            this.api.createTicketDetail(ticketDetailsData1).subscribe(successCode => {
              this.isSpinning = false;
              if (successCode['code'] == "200") {
                // this.drawerClose();
                this.isSpinning = false;
                this.DESCRIPTION = "";
                this.fileDataLOGO_URL = null;
                this.imageSrc = '';
                this.message.success("Sent successfully", "");
                this.refreshChat(data1.ID);

                data1.LAST_RESPONDED = this.date1
                if (data1['FIRST_RESOLVED_TIME'] == null)
                  data1['FIRST_RESOLVED_TIME'] = this.date1;

                data1.STATUS = "R";

                this.api.updateTicket(data1).subscribe(successCode => {
                  if (successCode['code'] == "200") {
                    // this.drawerClose();
                    this.fileDataLOGO_URL = null;
                    this.DESCRIPTION = '';
                  }
                });

              } else {
                this.isSpinning = false;
                this.message.error("Failed to Send", "");
              }
            });

          } else {
            this.isSpinning = false;
            this.message.error("Failed to upload file", "");
          }
        });

      } else {
        var ticketDetailsData1 = {
          ID: 0,
          SENDER: "S",
          CLIENT_ID: this.api.clientId,
          SENDER_ID: this.userId,
          TICKET_MASTER_ID: data1.ID,
          DESCRIPTION: this.DESCRIPTION,
          URL: this.genarateKeyLOGO_URL(),
          PRIORITY:this.PRIORITY
        }

        this.api.createTicketDetail(ticketDetailsData1).subscribe(successCode => {
          this.isSpinning = false;
          if (successCode['code'] == "200") {
            // this.drawerClose();
            this.isSpinning = false;
            this.DESCRIPTION = "";
            this.fileDataLOGO_URL = null;
            this.imageSrc = '';
            this.message.success("Sent successfully", "");
            this.refreshChat(data1.ID);

            data1.LAST_RESPONDED = this.date1;
            data1.STATUS = "R";

            this.api.updateTicket(data1).subscribe(successCode => {
              if (successCode['code'] == "200") {
                // this.drawerClose();
                this.fileDataLOGO_URL = null;
                this.DESCRIPTION = '';
              }
            });

          } else {
            this.isSpinning = false;
            this.message.error("Failed to Send", "");
          }
        });
      }

    } else {
      this.message.error("Please mention your solution.", "");
    }
  }

  send2(data1: Ticket) {
    var SENDER, SENDER_ID, TICKET_MASTER_ID, DESCRIPTION, URL
    var ticketDetailsData1 = {
      ID: 0,
      SENDER: "S",
      CLIENT_ID: this.api.clientId,
      SENDER_ID: this.userId,
      TICKET_MASTER_ID: data1.ID,
      DESCRIPTION: this.DESCRIPTION,
      URL: this.genarateKeyLOGO_URL(),
      PRIORITY:this.PRIORITY
    }

    this.isSpinning = true;
    this.api.createTicketDetail(ticketDetailsData1).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.drawerClose();
        this.isSpinning = false;
        this.DESCRIPTION = "";

      } else {
        this.message.error("Failed", "");
      }
    });

    data1.STATUS = "R";
    data1.LAST_RESPONDED = this.date1;

    this.api.updateTicket(data1).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }

  takeTicket(data: Ticket) {
    data.IS_TAKEN = true;
    data.STATUS = 'S';
    data.TAKEN_BY_USER_ID = this.userId;

    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }

  closeTicket(data: Ticket) {
    data.STATUS = "C";

    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }
  isOk:boolean=false
  AnswercloseTicket(data: Ticket) {
    this.date1 = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');
    data.LAST_RESPONDED = this.date1;
    this.isOk = true;
    if (this.DESCRIPTION == null || this.DESCRIPTION.trim() == '') {
      this.isOk = false;
      this.message.error('Please Enter Solution', '');
    }

    else {
    data.STATUS = "C"
    data['KEY'] = 'SUPPORT_USER';
data.DESCRIPTION=this.DESCRIPTION
    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }
}
  keepOnHold(data: Ticket) {
    data.STATUS = "H";

    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }

  bannTicket(data: Ticket) {
    data.STATUS = "B";

    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }
  pickreplyTicket(data: Ticket) {
    data.IS_TAKEN=1
    data.TAKEN_BY_USER_ID=this.userId
    data.STATUS = "R";
    data['KEY'] = 'SUPPORT_USER';
data.DESCRIPTION=this.DESCRIPTION
    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }

  unbannTicket(data: Ticket) {
    data.STATUS = "O";
    data['ACTION'] = 'UNBANNED';

    this.isSpinning = true;
    this.api.updateTicket(data).subscribe(successCode => {
      if (successCode['code'] == "200") {
        this.isSpinning = false;
        this.drawerClose();
        this.fileDataLOGO_URL = null;
        this.DESCRIPTION = '';
      }
    });
  }
  getFileName(fileUrl: string): string {
  return fileUrl.split('/').pop() || 'download';
}
  getSafeUrl(url: string): SafeResourceUrl {
  return this.sanitizer.bypassSecurityTrustResourceUrl(this.getUrl(url));
}
isImage(fileType: string): boolean {
  return fileType && fileType.startsWith("image/");
}
  genarateKeyLOGO_URL() {
    if (this.fileDataLOGO_URL) {
      var number = Math.floor(100000 + Math.random() * 900000);
      var fileExt = this.fileDataLOGO_URL.name.split('.').pop();
      var url = this.date1 + number + "." + fileExt;
      console.log(this.fileDataLOGO_URL);
      this.api.onUpload(this.folderName, this.fileDataLOGO_URL, url);
      var LOGO_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
      return LOGO_URL;

    } else {
      return "";
    }
  }
  getFileName1(url: string): string {
  if (!url) return '';
  return url.split('/').pop() || url;
}

  getUrl(url) {
    if (url)
      return this.api.baseUrl + "static/ticket/" + url
    else
      return ""
  }

  urlClick(url) {
    window.open(this.api.baseUrl + "static/ticket/" + url);
  }

  clearImg() {
    this.fileDataLOGO_URL = null
       this.imageSrc = '';
     this.uploadPercent = 0;
  }

onFileSelectedLOGO_URL(event: any) {
  const file: File = event.target.files[0];
  if (!file) return;

  this.fileType = file.type; // ✅ store type

  const maxSize = 2 * 1024 * 1024;
  if (file.size > maxSize) {
    this.message.error("Attachment size must be less than 2MB", "");
    event.target.value = '';
    this.fileDataLOGO_URL = null;
    this.imageSrc = '';
    return;
  }

  this.fileDataLOGO_URL = file;

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    this.imageSrc = reader.result as string;
  };

  this.uploadFile(file);
}
uploadFile(file: File) {
  this.uploadPercent = 0;
  const interval = setInterval(() => {
    if (this.uploadPercent < 100) {
      this.uploadPercent += 10; 
    } else {
      clearInterval(interval); 
      // upload complete -> आता progress hide होईल
    }
  }, 200);
}
 isImage1(): boolean {
  return this.fileType.startsWith('image/');
} 
 drawerVisible: boolean;
  drawerTitle: string;
  transferTicketDrawerData = [];

  @ViewChild(TransferTicketDrawerComponent, { static: false }) TransferTicketDrawerComponentVar: TransferTicketDrawerComponent;

  transferTicket(data) {
  this.data.STATUS="S"
    this.TransferTicketDrawerComponentVar.EMPLOYEE_ID = undefined;
    this.drawerTitle = "Transfer > " + "Ticket No. " + data.TICKET_NO;

    // Get Department Wise Employee for Transfer Ticket
    this.transferTicketDrawerData = [];
    this.TransferTicketDrawerComponentVar.isLoading = true;
    this.isSpinning = true;

    // this.api.getAllemployeeMaster(0, 0, '', '', ' AND ID<>' + this.userId + ' AND  ID in(SELECT EMPLOYEE_ID from view_employee_role_mapping where ORG_ID = ' + this.cookie.get('orgId') + ' AND ROLE_ID=4) AND STATUS=1 AND DEPARTMENT_ID=' + data.DEPARTMENT_ID).subscribe(data => {
    this.api.getAllemployeeMaster(0, 0, '', '', ' AND ID<>' + this.userId + ' AND  ID in(SELECT EMPLOYEE_ID from view_employee_role_mapping where ORG_ID = ' + this.cookie.get('orgId') + ' AND ROLE_ID=4) AND STATUS=1').subscribe(data => {
      if (data['code'] == 200) {
        this.isSpinning = false;
        this.TransferTicketDrawerComponentVar.isLoading = false;
        this.transferTicketDrawerData = data['data'];
        this.drawerVisible = true;
      }

    }, err => {
      console.log(err);
    });
  }

  transferTicketDrawerClose(): void {
    console.log(this.data);
    this.refreshChat(this.data.ID);
    this.drawerVisible = false;
  }

  get transferTicketCloseCallback() {
    return this.transferTicketDrawerClose.bind(this);
  }

  uniqueDateArry = [];
  newData2 = [];
  @ViewChild('scrollDown', { static: false }) scrollDownVar: ElementRef;

  refreshChat(ticketNo) {
    this.data2 = [];
    this.newData2 = [];
    this.uniqueDateArry = [];
    let filter = " AND TICKET_MASTER_ID=" + ticketNo;

    this.isSpinning = true;
    this.api.getAllTicketDetails(0, 0, "CREATED_MODIFIED_DATE", "asc", filter).subscribe(data => {
      if (data['code'] == 200) {
        this.isSpinning = false;
        var data1 = data['data'];

        // Getting Unique dates
        for (var i = 0; i < data1.length; i++) {
          this.uniqueDateArry.push(this.datePipe.transform(data1[i]['CREATED_MODIFIED_DATE'], "yyyy-MM-dd"));
        }

        this.uniqueDateArry = [...new Set(this.uniqueDateArry)];
        this.uniqueDateArry.sort();

        this.uniqueDateArry.forEach(d1 => {
          this.newData2.push({
            key: d1, data: data1.filter(data =>
              this.datePipe.transform(data.CREATED_MODIFIED_DATE, "yyyy-MM-dd") == d1)
          });
        });

        this.data2 = this.newData2;
        this.scrollIntoViewFunction();
      }

    }, err => {
      console.log(err);
    });
  }


  scrollIntoViewFunction() {
    setTimeout(() => {
      document.getElementById("scrollDown").click();
    }, 500);
  }

  bottom() {
    document.getElementById('bottom').scrollIntoView();
  }
  downloadFile2() {
  if (!this.fileDataLOGO_URL || !this.imageSrc) {
    this.message.error("File not available for download", "");
    return;
  }

  // Check if base64 format आहे का
  if (!this.imageSrc.includes(',')) {
    this.message.error("Invalid file data", "");
    return;
  }

  const base64 = this.imageSrc.split(',')[1];
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: this.fileDataLOGO_URL.type || 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = this.fileDataLOGO_URL.name || "download";
  a.click();
  window.URL.revokeObjectURL(url);
}

}
